import { createAction } from "redux-actions";
export const receiveSignals = createAction("DATA/RECEIVE_SIGNALS");
export const receiveInitialSignals = createAction("INITIAL/RECEIVE_SIGNALS");
